module.exports = __webpack_public_path__ + "static/media/moses_gulch-02.26c7e044.png";